<div (click)="$event.stopPropagation()" class="me-2" *ngIf="isAdmin">
  <div (click)="goToDrawoutAdmin()"
    class="icon-btn d-flex align-items-center justify-content-center position-relative">
    <mat-icon matTooltip="Admin Portal" class="admin-icon">admin_panel_settings</mat-icon>
  </div>
</div>